import React from 'react'
import PropTypes from 'prop-types'
import lang from '../../static/lang.json'
import { linkStyle } from './TranslateToggle'

const LinkFoodServices = (props) => {
  // eslint-disable-next-line
  const isEng = props.label === lang.translation.fr || !props.label
  return (
    <span>
      <a
        style={{
          ...linkStyle,
          marginLeft: '.75rem',
        }}
        target="_blank"
        rel="noopener noreferrer"
        href={
          isEng
            ? 'https://marcangelofoodservice.com/'
            : 'https://marcangelofoodservice.com/fr'
        }
      >
        {isEng ? 'Food Service' : 'Les Service Alimentaire'}
      </a>
    </span>
  )
}
export const localeProps = PropTypes.oneOf(['/', 'en-ca', 'en-us', 'fr-ca'])

LinkFoodServices.propTypes = {}

LinkFoodServices.defaultProps = {
  link: '/',
}

export default LinkFoodServices
